// extracted by mini-css-extract-plugin
export default {"resetDataContainer":"ResetDataStatus__resetDataContainer--tmUeIj17Cyc6N8xzLycp","resetDataProgressContainer":"ResetDataStatus__resetDataProgressContainer--V0yecumw3T6zbESOlztg"};